export default __webpack_public_path__ + "static/media/clear.07983db4.svg";